// function to check if there is data in the API
const noData = data => !data || (Object.keys(data).length === 0 && data.constructor === Object) || data.length === 0

export default noData
